import { apiClient } from "../clients/api.client.ts";
import tippy, { animateFill } from 'tippy.js';

export class ProductTheme {

  private readonly productTable: HTMLElement | null;
  private readonly saveItemsButton: HTMLButtonElement | null;

  constructor() {
    this.productTable = this.getProductTable();
    this.saveItemsButton = this.getSaveItemsButton();
  }

  loadMyItems = () => {
    
  }

  getSaveItemsButton = () => {
    return document.getElementById("table-save-items") as HTMLButtonElement;
  }

  getProductTable = () => {
    return document.querySelector(".fasco-variant-table") as HTMLElement;    
  }

  handleAddToSaved = (productVariantId) => {
    try {
      apiClient.variants.addToSaved(productVariantId);
    } catch (e) {
    }
  }

  showApprovalMessage = () => {
    if(!this.saveItemsButton) return;
    const t = tippy(this.saveItemsButton, {
      content: "Added to my items",
      animateFill: true,
      plugins: [animateFill],
      trigger: 'manual',
      showOnCreate: true,
    });
    setTimeout(() => t.destroy(), 4000)
  }

  handleButtonClicked = () => {
    if (!window.localStorage.customer_id) {
      window.location.href = `/account/login?return_url=${encodeURIComponent(window.location.pathname)}`
      return;
    }
    let addedItems = false as boolean;
    if(this.productTable){
      const rows = this.productTable.querySelectorAll(".row-variant");      
      rows.forEach((row) => {
        const qtyInput: HTMLInputElement | null = row.querySelector(".product-quantity");
        if(!qtyInput) return;
        const qty = parseInt(qtyInput.value);
        if(qty < 1) return;
        const vid = parseInt(row.getAttribute("data-vid") ?? "");
        this.handleAddToSaved(vid);
        addedItems = true;
      });  
    }    
    if(addedItems === true){
      this.showApprovalMessage();
    }
  }

  addListeners = () => {
    if(this.saveItemsButton){
      this.saveItemsButton.addEventListener("click", this.handleButtonClicked.bind(this) );
    }
  };

  mount = async () => {
    this.loadMyItems();
    this.addListeners();
  }  
}